import { UserCheckIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ActiveUser = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <UserCheckIcon size={Sizes[size]} {...rest} color={fill} />;
};

ActiveUser.displayName = 'ActiveUser';
